export default "__VITE_ASSET__SMAFA9P$__"